export default __webpack_public_path__ + "static/1-bb1b337b1bd0c8abe4934b8bf447bf55.jpeg";